import React from 'react';
import Icon from 'utility/icomoon';
import { getUnitIcon } from 'views/screens/Units/utils';

interface EventMarkerPulseProps {
  unit: {
    unitId?: number;
    eventId?: number | null;
    eventColor?: string;
    themeId: number;
    ignitionState?: number;
  };
  selectedUnitIds?: number[];
  isUnitsRotationMarkersActive?: boolean;
  rotationStyle?: string;
  iconSize?: number;
  iconColor?: string;
}

const EventMarkerPulse: React.FC<EventMarkerPulseProps> = ({
  unit,
  selectedUnitIds,
  isUnitsRotationMarkersActive,
  rotationStyle,
  iconSize = 30,
  iconColor = 'rgba(128, 128, 128, 0.6)'
}) => {
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      {unit?.eventId !== 0 && unit?.eventId !== null && unit?.eventColor && (
        <span
          className="marker-unit-event-pulse"
          style={{
            borderColor: unit?.eventColor.startsWith('#')
              ? unit?.eventColor
              : `#${unit?.eventColor}`
          }}
        />
      )}      <Icon
        icon={`${getUnitIcon(unit.themeId)}${
          (selectedUnitIds?.length ?? 0) > 0 &&
          unit.unitId !== undefined &&
          !(selectedUnitIds ?? []).includes(unit.unitId)
            ? 'Colorless'
            : ''
        }`}
        style={
          isUnitsRotationMarkersActive && unit.ignitionState == 1
            ? {
                color: iconColor,
                transform: rotationStyle,
                transition: 'transform 0.2s ease-out'
              }
            : { color: iconColor }
        }
        size={iconSize}
      />
    </span>
  );
};

export default EventMarkerPulse;
